import { useSelector, shallowEqual } from 'react-redux';
import { isBynderScopeAllowedSelector, isPlatformAllowedSelector } from 'packages/store/user/user.selectors';
import useAccountPermissions from './accountPermissions';
import useEntityPermissions from './entityPermissions';

const isPlatformAllowedEqualityFn = (left, right) => shallowEqual(left.dep.sort(), right.dep.sort());

const useAccessRights = () => {
    const { isPlatformAllowed } = useSelector(isPlatformAllowedSelector, isPlatformAllowedEqualityFn);
    const isBynderScopeAllowedSelectorFn = useSelector(isBynderScopeAllowedSelector);
    const { isAccountRoleAssigned, isAccountActionAllowed, getAccountAssignedRole } = useAccountPermissions();
    const { isEntityActionAllowed, getIdentityRole, getIdentityRoleAllUsers } = useEntityPermissions(
        getAccountAssignedRole,
        isPlatformAllowed,
    );

    return {
        isPlatformAllowed,
        isBynderScopeAllowed: isBynderScopeAllowedSelectorFn,
        isAccountRoleAssigned,
        isAccountActionAllowed,
        getAccountAssignedRole,
        isEntityActionAllowed,
        getIdentityRole,
        getIdentityRoleAllUsers,
    };
};

export default useAccessRights;
